import React, { useEffect, useState } from "react";
import { history } from "../../../../store/configure/configureStore";
import {
  FaPlus,
  FaEllipsisVertical,
  FaEye,
  FaPen,
  FaFilter,
  FaClockRotateLeft,
} from "react-icons/fa6";
import { MdDelete, MdSearch } from "react-icons/md";
import { LuFileClock } from "react-icons/lu";
import { handleRowsPerPage } from "../../../controls/Pagination/Pagination";
import { capitalizeWords } from "../../../../utils/common";
import { ENABLE_FORCE_LOGOUT } from "../../../../constants/env";
import { MOBILE_USER_ACTIVITY_LOG } from "../../../../navigation/routes";

import { Header, DataTable } from "../../../common";
import {
  IconMenuOption,
  ButtonView,
  CardView,
  Input,
  Select,
  ModalView,
} from "../../../controls";
import { Role } from "../../../../constants/role";

import "./MobileAppUserManagementStyles.scss";

const MobileAppUserManagementView = ({
  //
  mobileUserList,
  fields,
  userData,
  showModal,
  currentPage,
  rowsPerPage,
  errors,
  //
  onChangeSearchInput,
  //
  handleInputChange,
  handleClear,
  handleTableRowsChange,
  handleChangePage,
  //
  onClickViewUser,
  handleCloseModal,
  //
  onClickSearch,
  onClickForceLogout,
  //
  rowsPerPageDropDownOptions,
  //
  subscriptionList,
  //
  onClickSubscriptionDropDownFilterOptions,
  persistedData,
  //
  userPermissions,
  userRole,
}) => {
  // console.log("userData", userPermissions);

  // const renderCommaSeparatedSubscriptions = (subscriptions) => {
  //   if (!subscriptions || subscriptions.length === 0) return "-"; // Return "-" if no subscriptions

  //   return subscriptions
  //     .map(
  //       (sub) =>
  //         `${sub.name || ""}${
  //           sub.subscriptionOfferingName
  //             ? ", " + sub.subscriptionOfferingName
  //             : ""
  //         }`
  //     )
  //     .join(", ");
  // };

  // const renderCommaSeparatedTopics = (topicMappingCollectionId) => {
  //   if (!topicMappingCollectionId || topicMappingCollectionId.length === 0)
  //     return "-"; // Return "-" if no topics

  //   return topicMappingCollectionId
  //     .map((topic) => topic.topicId?.name || "")
  //     .filter((name) => name) // Filter out any empty or undefined names
  //     .join(", ");
  // };

  const renderCommaSeparatedTopics = (topicMappingCollectionId) => {
    if (!topicMappingCollectionId || topicMappingCollectionId.length === 0) {
      return "-"; // Return "-" if no topics
    }

    return topicMappingCollectionId
      .map((topic) => topic.name || "") // Access the 'name' property directly
      .filter((name) => name) // Filter out any empty or undefined names
      .join(", ");
  };

  const renderToken = (token) => {
    if (!token || token.length === 0) return "-"; // Return "-" if no tokens

    return (
      <>
        {token.map((item, index) => (
          <span key={index}>
            {item.token}
            {index < token.length - 1 && ( // Conditionally add two <br /> tags if it's not the last token
              <>
                <br />
                <br />
              </>
            )}
          </span>
        ))}
      </>
    );
  };

  //--------------------------column headers

  const renderSubscriptionColumnHeader = (label) => {
    return (
      <div className="custom-column-header">
        <text>{label}</text>
        {userRole !== Role.Viewer && (
          <div className="sortIcon">
            {
              <IconMenuOption
                menuIcon={<FaFilter />}
                options={subscriptionList}
                name={"name"} //object contain "status" field ==> this is to access from iconMenuOption component
                showMenuOptions={true}
                onClickFilterOption={onClickSubscriptionDropDownFilterOptions}
                persistedData={persistedData?.subscription}
                multipleFilterAllowed={true}
              />
            }
          </div>
        )}
      </div>
    );
  };

  const columns = [
    {
      name: "Name",
      width: "27.5%",
      selector: (row) => capitalizeWords(row?.name) || "-",
    },
    {
      name: "Email",
      width: "30%",
      selector: (row) => row?.email || "-",
    },
    {
      name: "Status",
      width: "12.5%",
      selector: (row) => row?.status || "-",
    },
    {
      name: renderSubscriptionColumnHeader("Subscription"),
      width: "20%",
      // selector: (row) => renderCommaSeparatedSubscriptions(row?.subscriptions),
      selector: (row) =>
        renderCommaSeparatedTopics(
          row?.customParameters?.topicMappingCollectionId
        ),
    },
    {
      name: "Action",
      width: "10%",
      center: true,
      // cell: (row, rowIndex) => renderAction(row, rowIndex),
      cell: (row, rowIndex) => renderActionMenu(row, rowIndex),
    },
  ];

  //--------------------------action UI

  const renderActionMenu = (row) => {
    const menuList = [
      {
        icon: <FaEye size={15} color="#B6C7AA" title="View" />,

        onclick: () => {
          onClickViewUser(row);
          // history?.push(`/mobile-app-users/user-details/${row?._id}`);
        },
      },
      userPermissions?.includes("users_activity_log") && {
        icon: <LuFileClock size={15} color="#4B70F5" title="logs" />,

        onclick: () => {
          history?.push(`${MOBILE_USER_ACTIVITY_LOG}/${row?.userId}`);
        },
      },
    ];

    return (
      <div className="action-menu-wrapper d-flex gap-3">
        {menuList.map((item) => {
          return (
            <div className="menu-item" onClick={item?.onclick}>
              {item?.icon}
            </div>
          );
        })}
      </div>
    );
  };

  //--------------------------View modal UI
  const renderViewBody = () => {
    console.log("user data", userData);

    const user = [
      { label: "Name", value: capitalizeWords(userData?.name) || "-" },
      { label: "Email", value: userData?.email || "-" },
      {
        label: "Subscription",
        value:
          renderCommaSeparatedTopics(
            userData?.customParameters?.topicMappingCollectionId
          ) || "-",
        // renderCommaSeparatedTopics(userData?.subscriptions) || "-",
      },
      {
        label: "Sky Attended",
        value: userData?.isMandatoryWorkshopAttended ? "Yes" : "No" || "-",
      },
      {
        label: "Sahaj Attended",
        value: userData?.isSahajGraduate ? "Yes" : "No" || "-",
        isLastItem: true,
      },
      // {
      //   label: "Token",
      //   // value: userData?.token || "-",
      //   value: renderToken(userData?.token) || "-",
      //   isToken: true,
      //   isLastItem: true,
      // },
    ];

    return (
      <div className="body-content-wrapper--mobile__app_user_management view-body-mobile-user">
        <div className="content-wrapper">
          {user.map((item, index) => (
            <div key={index}>
              <div
                className={`wrapper ${item.isLastItem && "no-bottom-border"}`}
              >
                <span className="label-wrapper">{item.label}</span>
                <span className="partition">:</span>
                <span
                  className={`content ${item.isToken && "wrap-content"} ${
                    (userData?.token?.length === 1 ||
                      userData?.token?.length === 0) &&
                    "content-wrap-fit-content"
                  }`}
                >
                  {item.value}
                </span>
              </div>
            </div>
          ))}
          {ENABLE_FORCE_LOGOUT && (
            <span className="body-action-block">
              <ButtonView
                title="Force Logout"
                styles={"secondary"}
                extraStyles={"btn-extras"}
                onClick={() => {
                  onClickForceLogout(userData?.userId);
                }}
              />
            </span>
          )}
        </div>
      </div>
    );
  };

  // console.log("mobileUserList Updated", mobileUserList);
  return (
    <div className="mobile__app_user_management--container">
      <div className="mobile__app_user_management--header-wrapper">
        <div className="title-content">Mobile App User Management</div>
        <div className="action-btn-wrapper">
          {/* {userPermissions?.includes("add_user") && (
            <ButtonView
              title="Add User"
              styles={"secondary"}
              icon={<FaPlus />}
              onClick={onClickAddUser}
            />
          )} */}
        </div>
      </div>
      <div className="mobile__app_user_management--table-wrapper">
        <div className="controls-wrapper">
          <div className="row-control-wrapper">
            <Select
              value={rowsPerPage}
              placeholder={10}
              options={rowsPerPageDropDownOptions}
              onChange={(val) => {
                handleTableRowsChange(val);
              }}
              isRowCap={true}
            />{" "}
            entries per page
          </div>
          <div className="row-control-wrapper">
            Search:{" "}
            <Input
              name={"searchString"}
              value={fields?.searchString}
              isrequired={true}
              onChange={(e) => onChangeSearchInput(e)}
              placeholder={"Type here to search"}
              showClearIcon={fields?.searchString ? true : false}
              handleClear={handleClear}
              error={errors["searchString"]}
              isSearchInput={true}
              autocomplete="off"
            />
            <div className="search-action-wrapper">
              <ButtonView
                // title="Search"
                icon={<MdSearch size={20} color="#eca55a" />}
                styles={"secondary"}
                size={"medium btn"}
                onClick={() => onClickSearch()}
              />
            </div>
          </div>
        </div>
        <div className="table-content">
          <DataTable
            columns={columns}
            data={mobileUserList?.docs ? mobileUserList?.docs : []}
            highlightOnHover={true}
            pointerOnHover={true}
            fixedHeader={true}
            persistTableHead={true}
            //
            pagination={true}
            paginationServer={true}
            paginationPerPage={mobileUserList?.limit}
            paginationTotalRows={mobileUserList?.totalDocs}
            onChangeRowsPerPage={handleTableRowsChange}
            onChangePage={handleChangePage}
            currentPage={currentPage}
            //
          />
        </div>
      </div>
      <ModalView
        show={showModal.showViewModal}
        handleClose={handleCloseModal}
        center={true}
        size={"lg"}
        showCloseIcon={true}
        title={"User Details"}
        children={renderViewBody()}
      />
    </div>
  );
};

export default MobileAppUserManagementView;
